import { useRef } from 'react';

import { IUseRewards } from './types';

interface ICalculateReloadAmount {
  totalCents: number;
  currentPrepaidBalance: number;
}

export const calculateReloadAmount = ({
  totalCents,
  currentPrepaidBalance,
}: ICalculateReloadAmount): number => {
  if (totalCents > currentPrepaidBalance) {
    return totalCents - currentPrepaidBalance;
  }
  return 0;
};

const useRewards = ({ user, prepaidCard, serverOrder, tipAmount }: IUseRewards) => {
  // order gets cleared on repricing
  // preserving the previous value prevents flashes of content as repricing loads
  const reloadAmount = useRef(0);
  const currentPrepaidBalance = prepaidCard?.prepaid?.feFormattedCurrentBalance ?? 0;

  if (!serverOrder || !serverOrder.cart || !user) {
    return { reloadAmount: reloadAmount.current };
  }

  const {
    delivery,
    cart: { totalCents },
  } = serverOrder;

  // delivery.tipCents is null until the user advances to PAYMENT_REQUESTED
  // at the same time, totalCents increases by the tip amount
  // we needed to do this to render the correct grand total/tip as user advances
  const serverOrderTip = Number(delivery?.tipCents || 0);

  reloadAmount.current = calculateReloadAmount({
    totalCents: totalCents - serverOrderTip + Number(tipAmount || 0),
    currentPrepaidBalance:
      currentPrepaidBalance !== null
        ? currentPrepaidBalance
        : prepaidCard?.prepaid?.currentBalance ?? 0,
  });

  return { reloadAmount: reloadAmount.current };
};

export default useRewards;
